import { __assign, __rest } from "tslib";
import classNames from 'classnames';
import * as React from 'react';
var ListItemLabel = function (props) {
    var _a = props.prefix, prefix = _a === void 0 ? 'cn-ui-m-' : _a, className = props.className, children = props.children, others = __rest(props, ["prefix", "className", "children"]);
    return (React.createElement("div", __assign({}, others, { className: classNames("".concat(prefix, "list-item-title"), className) }), children));
};
export default ListItemLabel;
